<div class="alert alert-info">
<h1 class="text-center">
  Revising math is like watering a plant. If you do not water it, it will dry.
</h1>
</div>
<app-entry-list-recent></app-entry-list-recent>

<div class="entry-list row">

      <div *ngFor="let entry of entries; index as myCount" class="col-sm-4 py-1">
        <h5 class="title">
          <a routerLink="/blog/{{ entry.slug }}">{{ entry.title }}</a>
        </h5>
        <div class="published"> <i class="fa fa-calendar-o"></i> Published on {{ entry.date | date }} <i class='fa fa-user'></i> Boldungu Team</div>
      </div>

  </div>
